requestAnimationFrame(() => {
  if (!customElements.get('google-map')) {
    class GoogleMap extends HTMLElement {
      constructor() {
        super();

        themeBase.onDOMContentLoadedTrigger(() => {
          window?.google?.maps ? this.initMap() : this.loadScript();
        });
      }

      loadScript() {
        const script = document.createElement('script');

        script.onload = this.initMap.bind(this);
        script.setAttribute('src', `https://maps.googleapis.com/maps/api/js?sensor=false&key=${this.dataset.apiKey}`);
        document.head.appendChild(script);
      }

      getStyle(style = '1') {
        const styles = {
          'default': [],
          'greyscale': [{
            "featureType": "all",
            "elementType": "geometry.fill",
            "stylers": [{
              "weight": "2.00"
            }]
          }, {
            "featureType": "all",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#9c9c9c"
            }]
          }, {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [{
              "visibility": "on"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
              "color": "#f2f2f2"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }]
          }, {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }]
          }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
              "saturation": -100
            }, {
              "lightness": 45
            }]
          }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#eeeeee"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#7b7b7b"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "color": "#ffffff"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{
              "color": "#46bcec"
            }, {
              "visibility": "on"
            }]
          }, {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#c8d7d4"
            }]
          }, {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#070707"
            }]
          }, {
            "featureType": "water",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "color": "#ffffff"
            }]
          }],
          'dark': [{
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [{
              "saturation": 36
            }, {
              "color": "#000000"
            }, {
              "lightness": 40
            }]
          }, {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#000000"
            }, {
              "lightness": 16
            }]
          }, {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 17
            }, {
              "weight": 1.2
            }]
          }, {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "administrative.country",
            "elementType": "all",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "administrative.country",
            "elementType": "labels.text",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "administrative.locality",
            "elementType": "all",
            "stylers": [{
              "visibility": "simplified"
            }, {
              "saturation": "-100"
            }, {
              "lightness": "30"
            }]
          }, {
            "featureType": "administrative.neighborhood",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "administrative.land_parcel",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
              "visibility": "simplified"
            }, {
              "gamma": "0.00"
            }, {
              "lightness": "74"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "landscape.man_made",
            "elementType": "all",
            "stylers": [{
              "lightness": "3"
            }]
          }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 21
            }]
          }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 29
            }, {
              "weight": 0.2
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 18
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 16
            }]
          }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 19
            }]
          }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
              "color": "#000000"
            }, {
              "lightness": 17
            }]
          }],
          'light': [{
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
              "color": "#e9e9e9"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 29
            }, {
              "weight": 0.2
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 18
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 21
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
              "color": "#dedede"
            }, {
              "lightness": 21
            }]
          }, {
            "elementType": "labels.text.stroke",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "elementType": "labels.text.fill",
            "stylers": [{
              "saturation": 36
            }, {
              "color": "#333333"
            }, {
              "lightness": 40
            }]
          }, {
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f2f2f2"
            }, {
              "lightness": 19
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 17
            }, {
              "weight": 1.2
            }]
          }],
          'avocado': [{
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#aee2e0"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#abce83"
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#769E72"
            }]
          }, {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#7B8758"
            }]
          }, {
            "featureType": "poi",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "color": "#EBF4A4"
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
              "visibility": "simplified"
            }, {
              "color": "#8dab68"
            }]
          }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#5B5B3F"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "color": "#ABCE83"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
              "color": "#A4C67D"
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
              "color": "#9BBF72"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [{
              "color": "#EBF4A4"
            }]
          }, {
            "featureType": "transit",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#87ae79"
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#7f2200"
            }, {
              "visibility": "off"
            }]
          }, {
            "featureType": "administrative",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "visibility": "on"
            }, {
              "weight": 4.1
            }]
          }, {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#495421"
            }]
          }, {
            "featureType": "administrative.neighborhood",
            "elementType": "labels",
            "stylers": [{
              "visibility": "off"
            }]
          }],
          'blue-water': [{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#444444"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
              "color": "#f2f2f2"
            }]
          }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
              "saturation": -100
            }, {
              "lightness": 45
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
              "visibility": "simplified"
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{
              "color": "#46bcec"
            }, {
              "visibility": "on"
            }]
          }]
        };

        return styles[style];
      }

      initMap() {
        const {
          address,
          zoom,
          showMarker,
          style
        } = this.dataset;

        const map = new google.maps.Map(this, Object.assign({
          zoom: +zoom,
          scrollwheel: false,
          styles: this.getStyle(style)
        }, address === '' ? {
          center: {
            lat: -34.397,
            lng: 150.644
          }
        } : {}));

        new google.maps.Geocoder()
          .geocode({
            address
          })
          .then(result => {
            const {
              results
            } = result;

            map.setCenter(results[0].geometry.location);
            if (showMarker === 'true') this.initMarker(map, results);
            return results;
          })
          .catch(e => log(`Geocoder error: ${e}`));
      }

      initMarker(map, results) {
        const marker = new google.maps.Marker({
          map
        });
        marker.setMap();
        marker.setPosition(results[0].geometry.location);
        marker.setMap(map);
      }
    }

    customElements.define('google-map', GoogleMap);
  }
});